<template>
  <div>
		<div class="mgt-200 t-center">
        <img src="/images/no-degree-data-image.svg" alt="" class="no-degree-image mgx-auto">
    </div>
    <div class="mgt-24 t-center t-headline8 font-r">
        {{$t(msgData.msg1)}}
    </div>
    <div class="mgt-4 t-center t-body1 t-color-bodyGrayA">{{$t(msgData.msg2)}}</div>
</div>
</template>

<script>
// Components/Mixin/Extend/API define



export default {
  props: ['msgData'],
  name: "",
  data() {
    return {
    };
  },
  components: {
    
  },
  watch: {
    $route(to, from) {},
  },
};
</script>

<style scoped>
.no-board-data img {
    height: 143px;
    width: auto;
}
</style>